import React from 'react';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import { connect } from 'react-redux';
import ClientNewsEarnings from '../news-earnings';

interface ICompanyNewsProps {
  currentCompany?: Bixby.Models.Company;
}

const CompanyNews: React.FC<ICompanyNewsProps> = props => {
  const { currentCompany } = props;
  if (Bixby.Utils.isNullOrEmpty(currentCompany)) {
    return null;
  }

  return currentCompany ? (
    <React.Fragment>
      <section>
        <ClientNewsEarnings
          companyId={currentCompany.id}
          companyName={currentCompany.name}
          dataSiteName={currentCompany.dataSiteName}
        />
      </section>
    </React.Fragment>
  ) : null;
};

const mapStateToProps = (state: AppState) => {
  return {
    currentCompany: state.portfolioState.currentCompany,
    isLoading: state.portfolioState.isLoading,
    error: state.portfolioState.error,
  };
};

export default connect(mapStateToProps)(CompanyNews);
